import { CSSProperties, ReactNode } from 'react';
import clsx from 'classnames';
import styles from './Wrapper.module.scss';

export function AppWrapper({ children }: { children: ReactNode }) {
	return <main className={clsx('__page', styles.overlayWrapper)}>{children}</main>;
}
export const overlayId = '__overlay';

export function OverlayWrapper({
	children,
	style = {},
}: {
	children: ReactNode;
	style?: CSSProperties;
}) {
	return (
		<div className={clsx(overlayId, styles.overlayWrapper)} style={style}>
			{children}
		</div>
	);
}
